<template>
    <kgr-profile-part :heading="memberShortProfile.fullNameWithTitle()">
        <template #content>
            <div class="kgr-postfix kgr-postfix--bigGutters">
                <div class="kgr-postfix__fixed">
                    <kgr-profile-image
                        :src="myAvatarUrl"
                        :alt="memberShortProfile.fullNameWithTitle()"
                        size="M"
                    />
                </div>
                <div class="kgr-postfix__fluid">
                    <table class="kgr-table">
                        <tbody>
                            <tr class="kgr-table__row kgr-table__row--top">
                                <td
                                    v-t="'memberShortProfile.gender'"
                                    class="kgr-table__cell"
                                ></td>
                                <td
                                    v-t="memberShortProfile.gender || 'gender.u'"
                                    class="kgr-table__cell"
                                ></td>
                            </tr>
                            <tr
                                v-if="memberShortProfile.dateOfBirth"
                                class="kgr-table__row kgr-table__row--top"
                            >
                                <td
                                    v-t="'memberShortProfile.dateOfBirth'"
                                    class="kgr-table__cell"
                                ></td>
                                <td class="kgr-table__cell">
                                    <div>
                                        {{ memberShortProfile.dateOfBirth }}
                                    </div>
                                    <div>
                                        ({{ formattedBirthday }})
                                    </div>
                                </td>
                            </tr>
                            <tr
                                v-if="memberShortProfile.departments && 0 !== memberShortProfile.departments.length"
                                class="kgr-table__row kgr-table__row--top"
                            >
                                <td
                                    v-t="'memberShortProfile.departments'"
                                    class="kgr-table__cell"
                                ></td>
                                <td class="kgr-table__cell">
                                    <div
                                        v-for="department in memberShortProfile.departments"
                                        :key="department"
                                    >
                                        ⸰ {{ department }}
                                    </div>
                                </td>
                            </tr>
                            <tr
                                v-if="memberShortProfile.teams && 0 !== memberShortProfile.teams.length"
                                class="kgr-table__row kgr-table__row--top"
                            >
                                <td
                                    v-t="'memberShortProfile.teams'"
                                    class="kgr-table__cell"
                                ></td>
                                <td class="kgr-table__cell">
                                    <div
                                        v-for="team in memberShortProfile.teams"
                                        :key="team"
                                    >
                                        ⸰ {{ team }}
                                    </div>
                                </td>
                            </tr>
                            <tr
                                v-if="memberShortProfile.dogRelations && memberShortProfile.dogRelations.length > 0"
                                class="kgr-table__row kgr-table__row--top"
                            >
                                <td
                                    class="kgr-table__cell"
                                >
                                    {{ $t('Hunde:') }}
                                </td>
                                <td class="kgr-table__cell">
                                    <div
                                        v-for="relation in memberShortProfile.dogRelations"
                                        :key="relation.id"
                                    >
                                        <a
                                            :href="`/backend/clubs/dogs/${relation.dog.id}/show`"
                                        >
                                            ⸰ {{ relation.dog.name }} ({{ $t('club.dog.memberRelation.association.' + relation.association) }})
                                        </a>
                                    </div>
                                </td>
                            </tr>
                            <tr
                                v-if="memberShortProfile.memberFilterFlags && 0 !== memberShortProfile.memberFilterFlags.length"
                                class="kgr-table__row kgr-table__row--top"
                            >
                                <td class="kgr-table__cell">
                                    {{ $t('memberShortProfile.memberFilterFlags') }}
                                </td>
                                <td class="kgr-table__cell">
                                    <div
                                        v-for="filterFlag in memberShortProfile.memberFilterFlags"
                                        :key="filterFlag.value"
                                    >
                                        ⸰ {{ filterFlag.value }}
                                    </div>
                                </td>
                            </tr>
                            <tr
                                v-if="memberShortProfile.memberClassifications && 0 !== memberShortProfile.memberClassifications.length"
                                class="kgr-table__row kgr-table__row--top"
                            >
                                <td class="kgr-table__cell">
                                    {{ $t('memberShortProfile.memberClassifications') }}
                                </td>
                                <td class="kgr-table__cell">
                                    <div
                                        v-for="classification in memberShortProfile.memberClassifications"
                                        :key="classification.value"
                                    >
                                        ⸰ {{ classification.value }}: {{ classification.notice }}
                                    </div>
                                </td>
                            </tr>
                            <tr
                                v-if="null !== remainingSalesListCredits"
                                class="kgr-table__row kgr-table__row--top"
                            >
                                <td
                                    v-t="'Verfügbares Guthaben (Verkaufsliste):'"
                                    class="kgr-table__cell"
                                ></td>
                                <td class="kgr-table__cell">
                                    {{ remainingSalesListCredits }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </template>
    </kgr-profile-part>
</template>

<script>
import MemberShortProfile, {MemberShortProfileMember} from '../../../js/dto/MemberShortProfile.js';
import Money from '../../../js/dto/Money.js'
import ProfileImage from '../../common/ProfileImage.vue';
import ProfilePart from '../../short-profile/ProfilePart.vue';
import UrlMixin from '../UrlMixin.vue';
import moment from 'moment';

export default {
    name: 'KgrMemberPartBasic',
    components: {
        'kgr-profile-part': ProfilePart,
        'kgr-profile-image': ProfileImage,
    },
    mixins: [UrlMixin],
    props: {
        memberShortProfile: {
            type: [MemberShortProfile, MemberShortProfileMember],
            required: true,
        },
    },
    computed:{
        remainingSalesListCredits() {
            if (this.memberShortProfile.salesListCredits) {
                const salesListCredits = Money.fromData(this.memberShortProfile.salesListCredits);
                return salesListCredits.toLocalizedString() + ' ' + salesListCredits.currency;
            }
            return null;
        },
        myAvatarUrl() {
            return this.avatarUrl(this.memberShortProfile.id, this.memberShortProfile.hasAvatar, this.memberShortProfile.gender, this.memberShortProfile.avatarFileName)
        },
        formattedBirthday() {
            const years = moment().diff(moment(this.memberShortProfile.dateOfBirth, 'DD.MM.YYYY'), 'years');

            return this.$t('{years} Jahre', {years: years});
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">

</style>
